import {HttpClient} from '@angular/common/http';
import {FisherSciCartRequest} from '@app/modules/fs-cart/models/types/fs-cart-add-request.type';
import {FsCartAddResponseType} from '@app/modules/fs-cart/models/types/fs-cart-add-response.type';
import {CookieService} from 'ngx-cookie-service';
import {catchError, finalize, map, Observable, tap, throwError} from 'rxjs';
import {Injectable} from '@angular/core';
import {TfBlockUIService} from '@app/modules/tf-block-ui';
import {TfNotificationsService} from '@app/modules/tf-notifications';
import {TfWindowRefService} from '@app/modules/tf-window-ref';


@Injectable({
    providedIn: 'root'
})


export class FsCartService {
    constructor(private httpClient: HttpClient,
                private tfBlockUIService: TfBlockUIService,
                private window: TfWindowRefService,
                private tfNotificationsService: TfNotificationsService,
                private cookieService: CookieService,
    ) {
    }

    addToCartForFS(cart): Observable<FsCartAddResponseType> {
        return this.httpClient.post<any>(`/store1/addToCartService/service/?language=en&countryCode=US&headerString=`, cart).pipe(
            tap(response => ({

                cardId: response?.data?.cartId,
                lineItems: [
                    {
                        lineNo: response?.data?.cartletItems[0]?.partNumber,
                        quantity: response?.data?.cartletItems[0]?.quantity,
                    }
                ]
            })),
            catchError(err => {
                return throwError(err);
            }),
        );
    }

    addToCartSubscriberForFS(cart: FisherSciCartRequest): Observable<FsCartAddResponseType> {
        this.tfBlockUIService.start();
        return this.addToCartForFS(cart).pipe(
            map((res: FsCartAddResponseType) => {
                if (res.wasAdded) {
                    res.cartResponseMessage = 'Added To Cart';
                    res.isCartAddSuccessful = true;
                    this.displayMiniCart(cart,res);
                    this.analyticsForAddToCart(cart, res);
                } else {
                    this.tfNotificationsService.showErrorHtml('Unexpected error adding items to cart. Please try again later', 'Error adding to cart', {
                        toastClass: 'availability-notification',
                        timeOut: 10000,
                        extendedTimeOut: 10000
                    });
                    res.isCartAddSuccessful = false;
                    if (res.messageList && res.messageList.length > 0) {
                        res.cartResponseMessage = res.messageList[0];
                    } else {
                        res.cartResponseMessage = 'Unable to add to Cart';
                    }
                }
                return res;
            }),
            catchError(err => {
                this.tfNotificationsService.clear();
                this.tfNotificationsService.showErrorHtml("Unexpected error adding items to cart. Please try again later", "Error adding to cart", { toastClass: 'availability-notification',timeOut: 10000, extendedTimeOut: 10000 } );
                console.error(err);
                return throwError(err);
            }),
            finalize(() => {
                this.tfBlockUIService.stop();
            })
        );
    }

    displayMiniCart(cart: FisherSciCartRequest, res: FsCartAddResponseType) {

        //Rearm the cart
        try {
            this.window.nativeWindow.header.cart.reArmCartLink();
            this.window.nativeWindow.header.cart.updateCount(res.cartLineItems); //'count' is the total number of items in the cart  ( 'cartLineItems' from add to cart JSON response )
        } catch (e) {
            console.error(e);
        }

        //overlay - only fire this if there's one product added.  Skip this for multiple items for now
        if (this.cookieService.get('new_overlay') && cart.itemList.length > 0) {

            // Define the overlay method and data
            const overlayData = res;
            // Define the URL
            const url = '/store1/cart/cartOverlay/' + cart.itemList[0].partNumber + '?language=' + 'en' + '&countryCode=' + 'US';

            this.httpClient.post(url, overlayData,{ responseType: 'text' }).subscribe(
                response => {

                    const doc = this.window.nativeDocument;
                    // Clean up previous overlay if needed
                    const existingOverlay = doc.querySelector('#cartOverlayWrapper');
                    if (existingOverlay) {
                        doc.querySelectorAll('#cartOverlayWrapper, #pageOverlay').forEach(el => el.remove());
                    }

                    if(response && doc.getElementById('cart-link-a')) {
                        doc.getElementById('cart-link-a').click();
                    }

                },
                error => {
                    console.error('Error:', error);
                }
            );
        }
    }

    analyticsForAddToCart(cart: FisherSciCartRequest, res: FsCartAddResponseType) {
        let scOpenCartEvent = '';
        let expiry;
        const analyticsProductString = [];

        //Check for cookie that indicates a cart add has occurred in the last 60 minutes
        if (!this.cookieService.get('addToCartInitiated')) {
            // set a new cookie to indicate a product was added to the cart
            expiry = new Date();
            expiry.setTime(expiry.getTime() + (60 * 60 * 1000)); // 60 minutes
            // Date()'s toGMTSting() method will format the date correctly for a cookie
            this.cookieService.set('addToCartInitiated', 'yes', {expires: expiry, path: '/'});
            scOpenCartEvent = ',scOpen';
        }

        //Loop through all part numbers and build the data layer to hold the product string ( please update with your own variable names, etc )
        cart.itemList.forEach(item => {
            analyticsProductString.push(';' + item.partNumber + ';;;;eVar33=Magellan Search');
        })

        //Fire the analytics for add to cart
        const fisherDataLayer = this.window.nativeWindow.fisherDataLayer || {};
        fisherDataLayer.productData = {};
        fisherDataLayer.linkTrackVars = 'products,events,eVar28,eVar33';
        fisherDataLayer.linkTrackEvents = 'scAdd' + scOpenCartEvent;
        fisherDataLayer.events = 'scAdd' + scOpenCartEvent;
        fisherDataLayer.products = analyticsProductString.join(',');


        //Misc Data Layer requests
        fisherDataLayer.productData.cartId = res.cartId;
        fisherDataLayer.productData.cartTotal = res.subTotal;
        fisherDataLayer.productData.addToCartFrom = 'Magellan';

        fisherDataLayer.customLinkGeneral = 'Add to Cart from Magellan Search';

        const _satellite = this.window.nativeWindow._satellite || {};
        if (typeof _satellite !== 'undefined' && _satellite.track) {
            _satellite.track('addToCartGeneral');
        }
    }

    getGlobalCart() {
        return this.window.nativeWindow.miniCart;
    }
}
